var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"breakdance-typography-input-controls mt-2"},[_c('ControlsTreeExpansionPanels',{attrs:{"controls":_vm.typographyControls,"path":"customTypography","allow-popouts-in-root":true,"nested":true,"depth":2}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }